// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Hlli","unreadBadge":"styles_unreadBadge__3U4y1","modalContent":"styles_modalContent__1nHBL","modal":"styles_modal__2cy2n"};